// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1LhaF","label":"Radio_label__1Ox1I","checkMark":"Radio_checkMark__1tfJS","disabled":"Radio_disabled__3rjuV"};